import React from 'react'
import { TerminalStatus, TerminalStatusContext } from '../../../types/mf-execution.types'
import { AllStatusWrapper } from '../../../components/execution/terminal/AllStatusWrapper'
import { postCTA } from '../../../utils/appBridge'
import { getOrdersTabCTA } from '../../../utils/mutualFundDetail'

const WithdrawSuccessPage: React.FC = () => {
  return (
    <div className='w-full h-screen relative overflow-hidden'>
      <AllStatusWrapper
        status={TerminalStatus.FULL_SUCCESS}
        statusContext={TerminalStatusContext.WITHDRAW}
        fullSuccessConfig={{
          title: 'Withdrawal requested',
          caption: 'Your request will be processed within 3-4 working days.',
          ctas: [
            {
              ctaType: 'secondary',
              label: 'Go to dashboard',
              onClick: () => {
                // Handle navigation to dashboard
                console.log('Navigate to dashboard')
                postCTA(JSON.stringify(getOrdersTabCTA()))
              }
            }
          ]
        }}
      />
    </div>
  )
}

export default WithdrawSuccessPage
